import type { TemplateChange } from './changes';

export type SectionId = string;

export type RegisterSection = (
  sectionId: SectionId,
  element: HTMLElement | null
) => void;

export type ReplicaStatus = 'loading' | 'ready' | 'notFound' | 'error';

export type ReplicaLoadFailure = Extract<ReplicaStatus, 'notFound' | 'error'>;

export type VisibilityOperationKind =
  | 'hideSection'
  | 'unhideSection'
  | 'hideQuestion'
  | 'unhideQuestion';

export type OperationKind = VisibilityOperationKind | 'reorder';

export type OpKey = `${OperationKind}:${string}`;

export type PendingOp = {
  kind: OperationKind;
  targetId: string;
  change: TemplateChange;
};

export type FailureOutcome = 'definite' | 'unknown';

export type OperationFailure = {
  outcome: FailureOutcome;
  message: string;
  cause: unknown;
};

export type BlockedReason =
  | 'SAME_TARGET_IN_FLIGHT'
  | 'REORDER_IN_FLIGHT'
  | 'MUTATION_IN_FLIGHT'
  | 'REPLICA_STALE'
  | 'NOT_PERMITTED';

export type StaleReason = 'outcomeUnknown';

export type RefreshFailure = {
  messageKey: string;
  cause: unknown;
};

export type RefreshAttempt =
  | { status: 'idle' }
  | { status: 'inFlight' }
  | { status: 'failed'; failure: RefreshFailure };

export type TemplatePermissions = {
  canManage: boolean;
  canReorder: boolean;
};

const VISIBILITY_OPERATION_KINDS: Record<OperationKind, boolean> = {
  hideSection: true,
  unhideSection: true,
  hideQuestion: true,
  unhideQuestion: true,
  reorder: false,
};

export function isVisibilityOperation(
  kind: OperationKind
): kind is VisibilityOperationKind {
  return VISIBILITY_OPERATION_KINDS[kind];
}

export function createOpKey(kind: OperationKind, targetId: string): OpKey {
  return `${kind}:${targetId}`;
}
